import React, {Fragment, useEffect, useState, useRef } from 'react'
import * as R from 'ramda'
import tremApi, {nullExceptParameter} from '../../../../../../util/tremApi'
import G from '../../../../../../util/globalFunction'

import ModalBox, { usePopup } from '../../../../../../components/modalBox'
import DeptSearch from '../../../../component/popup/popupDeptSelect'
import Cookies from 'js-cookie'

export default props =>{
    // 부서목록 상세 state
    const [gridDetail, setGridDetail] = useState({
        COMPANY_SKEY:props?.COMPANY_SKEY??"",
        CODE: "",
        DEPT_NAME: "",
        DEPT_SKEY: "",
        DIRECTOR: null,
        DIRECTOR_NAME: "",
        STATUS: "A",
        NOTE: "",
        deptStatus:false
    })

    // 코드 state
    const [codeMapList, setCodeMapList] = useState({}) 

    useEffect(() => {
       const params = {}
       params['CODE_LIST[0].GRP_NAME'] = '활성여부'
       params['CODE_LIST[0].ALIAS'] = 'active'

       tremApi('/r/code/part/inquiry', nullExceptParameter(params))
       .then((obj)=>{
            setCodeMapList(obj)
       })
       
    }, [])

    //부서저장 유효성검사
    const deptValidated = () =>{
        let pass = true
        R.isNil(gridDetail?.DEPT_NAME)===true||gridDetail?.DEPT_NAME===""&&alert(G.t('trem.lang.home.0992'),G.t('trem.lang.home.1137')).then(pass=false)  /* 부서명을 입력해주세요. */
        return pass
    }

    //부서저장 prams
    const setDeptSavePrams =gridDetail=>{
        let res = gridDetail
        Object.keys(res).forEach(k => {
                if(R.isNil(res[k])){
                    delete res[k]
                }
        })
        return res
    }

    //부서저장
    const detailDeptSave = () =>{
        delete gridDetail.deptStatus
        const pass = deptValidated()
        let savePrams = setDeptSavePrams(gridDetail)
        if(R.isNil(props?.COMPANY_SKEY)===false&&props?.COMPANY_SKEY!==""){
            /* 저장하시겠습니까? */ /* 확인 */
            pass&&G.confirm(G.t('trem.lang.home.0921'),G.t('trem.lang.home.0287'))
            .then(ok =>{
                ok&&tremApi('/company/dept/save',savePrams).then((res)=>{
                    if(res){
                        props.setDeptGrid(1)
                        props.handleClose()
                    }
                })
            })
        }else{
            alert(G.t('trem.lang.home.1035'),G.t('trem.lang.home.1137')) /* 기업을 먼저 선택해주세요. */
        }   
        
    }

    // 부서 검색 팝업
    const deptPopupProps = usePopup('trem.lang.home.0277')/* usePopup 부서 선택 */
    const DeptPopup = popupProps=>{
        const { open, handleClose } = popupProps
        let popupVal = {}
        const buttons = [
            {
                title: G.t('trem.lang.home.0200'),/* 선택 */
                className: 'red',
                handler: () => {
                    const {DEPT_SKEY, CODE, DEPT_NAME, STATUS, DIRECTOR, DIRECTOR_NAME, NOTE} = popupVal
                    if(DEPT_SKEY){
                        setGridDetail({...gridDetail, DEPT_SKEY, CODE, DEPT_NAME, STATUS, DIRECTOR, DIRECTOR_NAME, NOTE})
                        handleClose()
                    }else {alert(G.t('trem.lang.home.0994'), G.t('trem.lang.home.1137')) /* 선택된 부서가 없습니다. */ }
                
                },
            },
            {
                title: G.t('trem.lang.home.0146'),/* 닫기 */
                handler: handleClose,   
            },
        ]
        const getPopupValue = obj =>{
            popupVal = obj
            
        }
        const deptSearchProps ={
            SINGLE_MODE:"SINGLE",
            COMPANY_SKEY:props?.COMPANY_SKEY,
            CHOICE_IN_NULL:"Y",
            detail:true,
            getPopupValue
        } 
        return (
            open && (
                <ModalBox {...popupProps} buttons={buttons}>
                    <DeptSearch {...deptSearchProps}/>
                </ModalBox>
            )
        )
    }

    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    return(
        <Fragment>
            <div className="table_box">
                <table className="table_type2">
                    <caption>소속추가 팝업 표 - 부석코드, 부서명, 부서장, 상태, 비고로 구성</caption>
                    <tbody>
                        <tr>
                            <th scope='row'><label htmlFor="DEPT_CODE">{G.t('trem.lang.home.0530')}</label></th>{/* 부서코드 */}
                            <td><input title="부서코드 입력" id="DEPT_CODE" type="text" name="" value={gridDetail.CODE} onChange={(e)=>{setGridDetail({...gridDetail, CODE:e.target.value})}} readOnly/></td>
                        </tr>                               
                        <tr>
                            <th scope='row'><label htmlFor="DEPT_NAME">{G.t('trem.lang.home.0531')}</label> <span className="t_red">*</span></th>{/* 부서명 */}
                            <td>
                                {
                                gridDetail.deptStatus===true||gridDetail.CODE!==""?
                                <div className="flex flex-row">
                                    <input 
                                        title="부서명 선택입력"
                                        id="DEPT_NAME"
                                        type="text" 
                                        value={gridDetail.DEPT_NAME} 
                                        onChange={(e)=>{
                                            setGridDetail({...gridDetail, DEPT_NAME : e.target.value});
                                        }}
                                        style={{width:'80%'}}
                                    />
                                    {gridDetail.DEPT_SKEY===""||gridDetail.CODE===""?<a 
                                        className="w-2/6 btn1"
                                        style={{padding:"0px 8px", fontSize:"11px", textAlign:"center"}} 
                                        onClick={()=>{
                                        setGridDetail({...gridDetail, deptStatus:false})
                                        }}>
                                        선택입력
                                    </a>
                                    :""
                                    }
                                </div> 
                                :<div className="flex flex-row">
                                    <input 
                                    title="부서명 직접입력"
                                    id="DEPT_NAME"
                                    type="text"
                                    value={gridDetail.DEPT_NAME} 
                                    onChange={()=>{}} 
                                    disabled="disabled"
                                    style={{width:'50%'}}
                                    />
                                    <a href="javascript:void(0);" onClick={()=>{deptPopupProps.setOpen(true)}} className="btn1" style = {{padding: '0px 8px', fontSize:"11px"}}>{G.t('trem.lang.home.0036')}</a>{/* 검색 */}
                                    <a href="javascript:void(0);" 
                                    onClick={()=>{
                                    setGridDetail({...gridDetail, deptStatus:true, DEPT_SKEY:""})
                                    }} 
                                    className="btn1"
                                    style = {{padding: '0px 8px', fontSize:"11px"}}
                                    >
                                        {G.t('trem.lang.home.0490')} 
                                        {/* 직접입력 */}
                                    </a>
                                </div>
                                }
                            </td>
                        </tr> 
                        <tr>
                            <th scope='row'><label htmlFor="DIRECTOR_NAME">{G.t('trem.lang.home.0534')}</label></th>{/* 부서장 */}
                            <td>
                                <input 
                                id="DIRECTOR_NAME"
                                title="부서장 입력"
                                type="text" 
                                value={gridDetail.DIRECTOR_NAME}
                                onChange={(e)=>{
                                    setGridDetail({...gridDetail, DIRECTOR_NAME:e.target.value})
                                }}/>
                            </td>
                        </tr> 
                        <tr>
                            <th scope='row'><label htmlFor="STATUS">{G.t('trem.lang.home.0169')}</label></th>{/* 상태 */}
                            <td>
                                <select 
                                title="상태 구분"
                                id="STATUS"
                                value={gridDetail.STATUS} 
                                onChange={(e)=>{
                                    setGridDetail({...gridDetail, STATUS:e.target.value})
                                }}>
                                    {codeMapList?.active?.map((code,index)=>{
                                        return<option key={index} value={code.CODE}>{currentLang === "ko" ? code.NAME : code.ENG_NAME}</option>
                                    })} 
                                </select>
                            </td>
                        </tr> 
                        <tr className="t_cspan t_area_box">
                            <th scope='row'><label htmlFor="NOTE">{G.t('trem.lang.home.0074')}</label></th>{/* 비고 */}
                            <td>
                                <textarea 
                                title="비고 입력"
                                id="NOTE"
                                value={gridDetail.NOTE} 
                                onChange={(e)=>{
                                    setGridDetail({...gridDetail, NOTE:e.target.value})
                                }}></textarea>
                            </td>
                        </tr> 
                    </tbody>
                </table>
                <div className="btn_type4">
                    <a href="javascript:void(0);" onClick={()=>{detailDeptSave()}} className="red">
                        {G.t('trem.lang.home.0257')}
                        {/* 저장 */}
                    </a>
                </div>
            </div>
        <DeptPopup {...deptPopupProps} />
    </Fragment>
    )
    
}